import { supabase } from "../utils/supabase";

export async function getPostData(hash: number) {
    try {

        const { data, error } = await supabase
            .rpc('get_post_data', {
                hash_value: hash
            });

        if(error) {
            throw new Error(error.message);
        }
        else if(data !== null){
            return data[0];
        }
        else {
            throw new Error("Data is null");
        } 
    }
    catch(e) {
        console.error(e);
    }
}

